import { useInfiniteQuery } from 'react-query'

import { CMSList } from '../types/cms/cms-list'

export function useInfiniteScroll<T>(
    queryKey: string[],
    queryFn: (pageParam: number, slug: string | undefined) => Promise<CMSList<T>>,
    slug?: string,
    initialPage?: number
) {
    const result = useInfiniteQuery(
        queryKey,
        ({ pageParam = initialPage ?? 1 }) => {
            return queryFn(pageParam, slug)
        },
        {
            getNextPageParam: (lastPage) => {
                if (!lastPage.pages.hasNext) return false
                return lastPage.pages.next
            },
        }
    )

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Unreachable code error
    const list = result.data?.pages.reduce((prev, page) => prev.concat(page.data), []) ?? ([] as unknown)

    return { ...result, list }
}
